// import '@/assets/scss/app.scss';
import reportWebVitals from '@/config/reportWebVitals';
import { isNewRelicConfig, nrConfigurations } from '@/constants/configuration/newRelic.js';
import { Router } from '@/lib/router-dom';
import store from '@/redux/store.js';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';

if (!isNewRelicConfig()) {
	console.warn("Unknown environment for New Relic setup.");
} else {
	new BrowserAgent(nrConfigurations);
}

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<Router>
				<App />
			</Router>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
)

reportWebVitals();
